import React, { useEffect, useState } from "react";
import { useResume } from "../../context/ResumeContext";
import { removeBodyScroll } from "../../helper";
import { REVIEW_LANDINGPAGE_LINK } from "../../constants/constants";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
export const ActionButton = () =>{
    const [loader, setLoader] = useState({download: false, saveSpoof: false, share: false});
    const [saved, setSaved] = useState(false);
    const [redirect2, setRedirect2] = useState();
    const {
        setShowPreview,
        handlers: {
            onsaveResume,
        },
    } = useResume();

    useEffect(() => {
        if (saved) {
            const timer = setTimeout(() => {
                setSaved(false);
            }, 1500);
            return () => clearTimeout(timer);
        }
    }, [saved]);

    if (redirect2) return <Redirect to={redirect2} />
    

    return(
        <><span className="fixed-review-action-btn">
            <div className="review button button-3">
            <div className="save-action" onClick={() => {
                    onsaveResume();
                    setSaved(true);
                }}>
                <span><i className="icon-save"></i>{saved ? 'Saved!' : 'Save'}</span>

            </div>
            <div className="preview-btn" onClick={()=>{
                    setShowPreview(true);
                    removeBodyScroll(true);
                    ga4Track('app_editor_preview', 'RB App', 'Preview');
                    ga4Track('app_bottom_nav_preview', 'RB App', 'Bottom Nav: Preview');
                }}>
                <span><i className="icon-eye"></i>Preview</span>
            </div>
            <div className="done-btn" onClick={() => {
                setRedirect2(REVIEW_LANDINGPAGE_LINK)
            }}>
                <span className="done-btn"><i className="icon-info-done"></i>Done</span>
            </div>
        </div>
        </span>
        </>
    )
}